
<section class="hero-wrap hero-wrap-2"
    style="background-image: url('../../assets/images/bg_4.jpg');">
    <div class="overlay"></div>
    <div class="container">
        <div
            class="row no-gutters slider-text align-items-center justify-content-center">

        </div>
    </div>
</section>

<section class="ftco-section bg-light">
    <div class="container">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-12">
                <div class="wrapper">
                    <div class="row d-flex justify-content-center g-0">
                        <div class="col-lg-6">
                            <div class="contact-wrap w-100  wrap-content">
                                <h3>
                                    Delete Account
                                </h3>
                                <div *ngIf="!isDeleted">
                                    <p class="text-muted">Please be aware that
                                        deleting your account is irreversible
                                        and
                                        will erase all your data.</p>
                                    <form [formGroup]="deleteAccountForm"
                                        (ngSubmit)="onSubmit()">
                                        <div class="mb-3">
                                            <label for="confirm-delete"
                                                class="form-label">Type "DELETE"
                                                to confirm:</label>
                                            <input type="text"
                                                class="form-control"
                                                id="confirm-delete"
                                                name="confirm_delete"
                                                formControlName="confirm_delete">
                                            <!-- Display error message if input is invalid -->
                                            <div
                                                *ngIf="deleteAccountForm.get('confirm_delete').invalid && deleteAccountForm.get('confirm_delete').touched"
                                                class="text-danger">
                                                Please type exactly "DELETE".
                                            </div>
                                        </div>
                                        <input type="hidden" name="user_id"
                                            value="USER_ID">
                                        <!-- Replace USER_ID with the user's actual ID -->
                                        <button type="submit"
                                            class="btn btn-primary">Delete
                                            Account</button>
                                    </form>
                                </div>
                                <div *ngIf="isDeleted">
                                    <div class="alert alert-success mt-3"
                                        role="alert">
                                        Your account has been deleted
                                        successfully.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
